import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import NavLinks from './NavLinks'
import { Container } from 'components/layout/Grid/'
import styles from './Header.scss'
import EpicLogo from 'icons/IconEPICLogo'

const Header = ({ currentUser, history }) => {
  const showAdminLinks = window.location.href.includes('/admin')
  const showNavLinks = (!((window.location.href.includes('unauthorised') || window.location.href.includes('error'))))

  return (
    <div className={styles.base}>
      <Container className={styles.container}>
        <Link to="/">
          <EpicLogo className={styles.epicLogo} />
        </Link>
        {showNavLinks && <NavLinks
          currentUser={currentUser}
          history={history}
          showAdminLinks={showAdminLinks}
        />}
      </Container>
    </div>
  )
}

Header.propTypes = {
  currentUser: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.js